/**
 * PoppinPay API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The VariationInventoryResultModel model module.
* @module model/VariationInventoryResultModel
* @version 1.0.0
*/
export default class VariationInventoryResultModel {
    /**
    * Constructs a new <code>VariationInventoryResultModel</code>.
    * @alias module:model/VariationInventoryResultModel
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>VariationInventoryResultModel</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/VariationInventoryResultModel} obj Optional instance to populate.
    * @return {module:model/VariationInventoryResultModel} The populated <code>VariationInventoryResultModel</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new VariationInventoryResultModel();
                        
            
            if (data.hasOwnProperty('VariationId')) {
                obj['VariationId'] = ApiClient.convertToType(data['VariationId'], 'String');
            }
            if (data.hasOwnProperty('Count')) {
                obj['Count'] = ApiClient.convertToType(data['Count'], 'Number');
            }
            if (data.hasOwnProperty('LastUpdatedUtc')) {
                obj['LastUpdatedUtc'] = ApiClient.convertToType(data['LastUpdatedUtc'], 'Date');
            }
        }
        return obj;
    }

    /**
    * @member {String} VariationId
    */
    'VariationId' = undefined;
    /**
    * @member {Number} Count
    */
    'Count' = undefined;
    /**
    * @member {Date} LastUpdatedUtc
    */
    'LastUpdatedUtc' = undefined;




}
